<ng-container>
    <mat-form-field
            [style]="style"
            class="no-padding"
            appearance="outline"
            style="margin-top: -7px">
        <mat-chip-list #chipList aria-label="Tag selection">
            <mat-chip
                    *ngFor="let tag of userTags"
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="remove(tag)">
                {{tag}}
                <mat-icon matChipRemove
                          *ngIf="removable">cancel
                </mat-icon>
            </mat-chip>
            <input
                    placeholder="Izaberite tagove..."
                    #tagInput
                    [formControl]="tagCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete"
                          (optionSelected)="selected($event)">
            <mat-option *ngFor="let tag of tagsList "
                        [value]="tag">
                {{tag}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</ng-container>

